import * as Styled from '../styled'
import { Dinosaur } from '~components'

function NetworkError() {
  return (
    <Styled.Wrapper role="region" $large>
      <Dinosaur />
      <Styled.Title>Sem conexão</Styled.Title>
      <Styled.Description>
        Verifique os cabos de rede, modem e roteador. Se estiver conectado a uma rede
        Wi-Fi, tente se reconectar.
      </Styled.Description>
    </Styled.Wrapper>
  )
}

export default NetworkError
